import { FlexColumn, ModelForm } from '@equifinance/shared';
import AccountTabPage from '../Page/AccountTabPage';
import AccountStage from '../AccountStage';
import TasksSidebar from './TasksSidebar';
import { ApplicationPageType } from '../AccountTabNav';
import TaskToggleButtons from './components/TaskToggleButtons';
import TaskSection from './sections/TaskSection';
import ResourcesSection from './sections/Resources';
import { useTasksAutoSave, useTasksContext } from '../../contexts/tasks';

export default function TasksPage() {
  useTasksAutoSave();

  const { tasks, updateTasks, handleToggleAll } = useTasksContext();
  const { errors } = tasks;

  const update = (values: Record<string, any>, disableIncrementUpdateCount: boolean = false) => {
    Object.entries(values).forEach(([field, value]) => {
      updateTasks(field, value, disableIncrementUpdateCount);
    });
  };

  return (
    <AccountTabPage
      subHeader={<AccountStage />}
      sidebar={<TasksSidebar />}
      page={ApplicationPageType.TASKS}
    >
      <ModelForm model={tasks} update={update} errors={errors}>
        <FlexColumn>
          <TaskToggleButtons
            onExpandAll={() => handleToggleAll(true)}
            onCollapseAll={() => handleToggleAll(false)}
          />

          <ResourcesSection />
          <TaskSection />

        </FlexColumn>
      </ModelForm>
    </AccountTabPage>
  );
}
